import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/bundles";

class BundlesService {
  getBundles = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri učitavanju bundlova.");
    }
  };

  getActiveBundles = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/active`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri učitavanju aktivnih bundlova.");
    }
  };

  createBundle = async ({ productAId, productBId, discountAmount }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}`, {
        productAId,
        productBId,
        discountAmount,
      });
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri kreiranju bundla.");
    }
  };

  updateBundle = async (id, requestData) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/${id}`,
        requestData
      );
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri izmeni bundla.");
    }
  };

  deleteBundle = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri brisanju bundla.");
    }
  };
}

const bundlesService = new BundlesService();

export default bundlesService;
